// extracted by mini-css-extract-plugin
module.exports = {"landingFeatureListItem":"LandingFeatureListItem_landingFeatureListItem__2A2MD","text":"LandingFeatureListItem_text__2IK8o"};